import { render, staticRenderFns } from "./ThankYouMessage.vue?vue&type=template&id=4a309d82&"
import script from "./ThankYouMessage.ts?vue&type=script&lang=ts&"
export * from "./ThankYouMessage.ts?vue&type=script&lang=ts&"
import style0 from "./ThankYouMessage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports